import React, { useState, useEffect } from "react";
import { GetSchedule } from "../API";
import GeneralScheduleDayItem from "./GeneralScheduleDayItem";

export default function GeneralSchedule() {
  const [days, setDays] = useState([]);
  const [dayNumbers, setDayNumbers] = useState([])

  useEffect(() => {
    GetSchedule(0).then(data => {
      console.log(data);
      setDays(data.days);
      let max = 0;
      for (let i=0;i<data.days.length;i++) {

        if (data.days[i].timeToNo > max) max = data.days[i].timeToNo;
 
      }
      let dayNumbersTemp= [];
      for(let i=0;i<max;i++)
      dayNumbersTemp = dayNumbersTemp.concat(i+1)

      setDayNumbers(dayNumbersTemp)
    });
  }, []);
  return (
    <div class="card card-bottom-tabs">
      <div class="card-block">
        <h4 class="card-title m-t-0">Student Schedule</h4>

        <table class="gv gv_schedule">
          <tbody>
            <tr>
              <th scope="col" />

              {dayNumbers.map( item => <th scope="col">{item}</th> )}
     
            </tr>
            {days.map(item => (
              <GeneralScheduleDayItem data={item} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/student_schedule/GenearalSchedule/GeneralSchedule.js